import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import Switch from '../primitives/Switch';
import type { UserPreferences } from '../../types/api';

interface DisplayOptionsProps {
  preferences: UserPreferences;
  onCondensedViewToggle: (checked: boolean) => void;
  onThumbnailsToggle: (checked: boolean) => void;
  onReaderToggle?: (checked: boolean) => void;
  readerEnabled?: boolean;
  className?: string;
}

function DisplayOptions({
  preferences,
  onCondensedViewToggle,
  onThumbnailsToggle,
  onReaderToggle,
  readerEnabled,
  className,
}: DisplayOptionsProps) {
  return (
    <div className={className}>
      <div className="flex w-full items-center justify-between gap-1">
        <span className="text-sm">
          <Trans>Condensed</Trans>
        </span>
        <Switch
          checked={preferences.bookmarkList.view === 'condensed'}
          onChange={onCondensedViewToggle}
          aria-label={t`Toggle condensed view`}
        />
      </div>

      <div className="flex w-full items-center justify-between gap-1">
        <span className="text-sm">
          <Trans>Thumbnails</Trans>
        </span>
        <Switch
          checked={preferences.bookmarkList.thumbnails}
          onChange={onThumbnailsToggle}
          aria-label={t`Toggle thumbnails`}
        />
      </div>

      {onReaderToggle !== undefined && readerEnabled !== undefined && (
        <div className="flex w-full items-center justify-between gap-1">
          <span className="text-sm">
            <Trans>Reader</Trans>
          </span>
          <Switch
            checked={readerEnabled}
            onChange={onReaderToggle}
            aria-label={t`Toggle reader layout`}
          />
        </div>
      )}
    </div>
  );
}

export default DisplayOptions;
